import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { complaintModule } from '../../../../../../modules/complaints';
import { Observable } from "rxjs";
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MatPaginator } from '@angular/material/paginator';

import { Options } from 'selenium-webdriver';
import { query } from '@angular/animations';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'view-complaints',
  templateUrl: './view-complaints.component.html',
  styleUrls: ['./view-complaints.component.css']
})
export class ViewComplaintsComponent implements OnInit {
  @Output('onAction') emitter = new EventEmitter();
  @Output('pageAction') pageEmitter = new EventEmitter();

  pageNum = 1;
  limit;
  compStatus;

  public orgID;
  public userType;
  public userData;

  public pageLimit = 10;
  isShowCom: boolean;
  public activeComplaints = 'high';
  public complaintDetails: any = complaintModule;
  public values: any = [];

  public employeeData = [];
  public driverData = [];
  public tableData = [];

  // public page: number = 1;
  public ListCount = [];
  public totalCount = [];
  public pageValue;
  public noDataEnable: boolean = false;
  public editForm: boolean;
  public filterOptionValue = '0';
  public searchedValue;
  public filterOption = [
    { name: 'All', value: '0' },
    { name: 'Completed', value: 'completedCount' },
    { name: 'In-Progress', value: '2' },
    { name: 'Pending', value: '1' },
    { name: 'Rejected', value: '4' },
  ];
  searchChangeObserver: any;
  public showPagination: boolean = true;
  public paginationData = {
    page: 1,
    limit: 10,
    totalPage: 1,
  }




  public cols = [
    { key: 'complaintName', display: 'Complaint Name' },
    { key: 'department', display: 'Department' },
    { key: 'email', display: 'Email' },
    { key: 'accusedName', display: 'Accused Name' },
    //   { key: "country", display: "Country" },
    {
      key: 'action',
      display: 'Action',
      config: {
        isAction: true,
        actions: [
          { display: 'view', color: 'primary', icon: 'View' },
          { display: 'update', color: 'primary', icon: 'Edit', class:'fs-13' },
          { display: 'delete', color: 'warn', icon: 'Delete' }
        ]
      }
    }
  ];
  public empInfo: any = {};
  public complaintCount: any = {};
  public enableComplaintCount: boolean = false;
  public complaintData = [
    {
      complaintName: 'sdafs',
      department: 'Dept1',
      phoneNumber: '232332',
      email: 'rajae@groupten.com',
      date: '20/10/2020',
      accusedName: 'asfsdaf',
      accusedDepartment: 'Dept1',
      relationship: 'sdfdfsa',
      accusedPhoneNumber: '34344334',
      accusedEmail: 'dss@gmail.com',
      dateOfIncident: '22/10/2020',
      eventOccur: 'sdfsdfd',
      explainOccurred: 'sdfdsfdsf'
    },
    {
      complaintName: 'Com2',
      department: 'Dept2',
      phoneNumber: '232332443',
      email: 'rajasanthi19@groupten.com',
      date: '20/10/2020',
      accusedName: 'asfsdaf',
      accusedDepartment: 'Dept2',
      relationship: 'sdfdfsa',
      accusedPhoneNumber: '34344334',
      accusedEmail: 'dsseee@gmail.com',
      dateOfIncident: '24/10/2020',
      eventOccur: 'sdfsdfd',
      explainOccurred: 'sdfdsfdsf'
    }
  ];

  constructor(
    public api: ApiService,
    public swal: SweetAlert,
    public storage: StorageService,
    public router: Router,
  ) {
    this.orgID = this.storage.get('userInfo').orgID;
    this.userType = this.storage.get('userType');
    this.userData = this.storage.get('vendorViewData');
  }

  ngOnInit(): void {

    this.getComplaintList();
    this.getComplaintListCount();
  }

  getComplaintList(params: any = {
    search: undefined,
    compStatus: undefined
  }) {
    const obj = {
      // orgID: this.storage.get('userInfo').orgID
    };



    if (params && params['search']) {
      obj['search'] = params['search'];
    }

    if (params && params['compStatus']) {
      this.compStatus = +params['compStatus']
    }

    if (this.compStatus && this.compStatus!=-1) {
      obj['compStatus'] = +this.compStatus;
    }

    obj['page'] = this.pageNum;
    obj['limit'] = this.pageLimit;

    this.api.transportManagerComplaintList(obj).then((res: any) => {
      if (res.status == 'success') {
        // this.complaintCount = res.count;
        this.enableComplaintCount = true;
        this.complaintData = res.data;
        this.empInfo = res.empInfo;
        this.tableData = this.complaintData;
        this.noDataEnable = true;
        // console.log(this.complaintCount, this.complaintData);
        this.pageAdition();
      }
    }).catch((err) => {
      console.log(err);
    });

  };
  pagination(type, term) {
    if (type == 'next') {

      this.pageNum++;

    } else if (type == 'prev') {
      if (this.pageNum <= 1) return;

      this.pageNum--;

    }
    this.getComplaintList({ search: term });

  }


  pageAdition() {

    this.pageValue = this.pageLimit * (this.pageNum - 1);  ///('limit*(page-1)')
  }

  statusCount(type, term) {
   this.pageNum = 1;
    this.getComplaintList({ compStatus: type, search: term });
  }




  filterComplaintType(type) {
    this.filterOptionValue = type;
    this.filterTableData();
  }
  filterTableData() {
    this.tableData = [];

    if (this.filterOptionValue == '0') this.tableData = this.complaintData;
    else this.tableData = this.complaintData.filter((e) => e['complaintStatus'] == Number(this.filterOptionValue));

    if (this.searchedValue) this.tableData = this.tableData.filter((e) => e.title.toLowerCase().indexOf(this.searchedValue) == 0);
  }

  // get Employee Name
  getEmployeeName(id) {
    let name = '---';
    this.employeeData.filter((emp) => {
      if (emp.employeeID == id) name = emp.name;
    })
    return name;
  }

  // get Driver Name
  getDriverName(id) {
    let name = '---';
    this.driverData.filter((driver) => {
      if (driver.driverID == id) name = driver.name;
    })
    return name;
  }
  // list count
  getComplaintListCount() {
    const obj = {

    };

    this.api.transportManagerComplaintListCount(obj).then((res: any) => {

      if (res.status == 'success') {
        this.ListCount = res.data;
        this.totalCount = this.ListCount;
        // console.log(res)
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  // search
  onSearchChange(searchValue: string) {

    searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

    if (!this.searchChangeObserver) {
      new Observable(observer => {
        this.searchChangeObserver = observer;
      }).pipe(debounceTime(500)) // wait 300ms after the last event before emitting last event
        .pipe(distinctUntilChanged()) // only emit if value is different from previous value
        .subscribe((term: any) => {
          // your code here

          this.getComplaintList({ search: term });
        });
    }

    this.searchChangeObserver.next(searchValue);
  }


  // search


  onActionHandler(e: any) {
    // console.log(e)
    const data = e.data;
    if (e.action.display == 'update') {
      for (const f of this.complaintDetails) {
        const name = f.name;
        let value = '';
        if (f.type == 'dropdown') {
          const val = data[name].split(',');
          const temp = [], str = [];
          val.map(item => { temp.push({ value: val, name: val }); str.push(item); });
          f.selected = temp;
          f.value = str.join(',');
        } else {
          value = name;
          f.value = data[value];
        }

      }
      //   console.log(this.empFields)
      this.editForm = true;
    } else if (e.action.display.toLowerCase() == 'delete') {
      // console.log('openDeleteProductModal');
      //   this.openDeleteProductModal();
    }
  }

  // edit complaint
  takeAction(id) {
    this.router.navigate(['/organization/transport-manager/support-desk/complaint/action-complaint', id]);
  }

  submitForm(e: any) {

    if (e == 0) { this.editForm = false; } else {
      console.log(e);
    }
  }
  takeActionComp() {
    this.isShowCom = !this.isShowCom;
  }
  deleteComp() {

  }

  changeComplaintType(type) {
    this.activeComplaints = type;
  }
}





 // paginationLimit(){
  //   this.pageNum = 1;
  //   this.pageEmitter.emit({page:this.pageNum,limit: Number(this.pageLimit)});
  // }